import { HTMLAttributes } from "react";
import t from "@/lang/lang";
import { cn } from "@/shared/lib/utils";

export interface ReferenceNumberProps extends HTMLAttributes<HTMLSpanElement> {
  referenceNumber: string | undefined;
}

/**
 * ReferenceNumber displays the reference number of a document. Renders a
 * placeholder if the document has no reference number.
 */
export function ReferenceNumber({
  referenceNumber,
  className,
  ...props
}: ReferenceNumberProps) {
  return (
    <span className={cn("font-mono whitespace-nowrap", className)} {...props}>
      {referenceNumber ? referenceNumber : t("- keine Nummer -")}
    </span>
  );
}
